// extracted by mini-css-extract-plugin
export default {"tx":"_42f278cc49","line":"_23ef1d12e3"};